module.exports = __webpack_public_path__ + "img/main-03-01.df05fcde.png";